<template>
  <div class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full py-4 xl:pb-6">
      <div class="mb-8 md:px-6 lg:px-8 xl:px-20 xl:mb-12">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="1"
          />
        </div>
      </div>

      <div id="main-content" class="w-full viewport-gutter">
        <div class="container">
          <div class="text-sm xl:text-lg">
            <h1 class="pb-3 text-3xl font-bold leading-none xl:text-4xl font-lufthansa-head">
              {{ tr('pages.sales.buy.title') }}
            </h1>
            <p class="leading-snug">
              {{ tr('pages.sales.buy.description') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-3 pb-16 md:pt-12 md:pb-0">
      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="flex flex-col-reverse justify-between w-full xl:flex-row">
            <div class="w-full mb-12 max-w-104 md:flex md:max-w-none md:mb-8 xl:max-w-104 xl:block xl:pr-6 xl:mr-6 xl:mb-0">
              <div class="mt-10 mt-12 text-sm xl:w-1/2 xl:pl-10 xl:text-lg xl:w-full">
                <ul class="list-checkmark">
                  <li class="pt-1 pb-2 xl:pt-0 xl:pb-6" v-html="tr('pages.sales.buy.cards.point1')" />
                  <li class="pt-1 pb-2 xl:pt-0 xl:pb-6" v-html="tr('pages.sales.buy.cards.point3')" />
                  <li class="pt-1 pb-2 xl:pt-0 xl:pb-6" v-html="tr('pages.sales.buy.cards.point4')" />
                </ul>
              </div>
            </div>
            <VoucherAmountSelector class="w-full xl:max-w-183" />
          </div>
        </div>
      </div>

      <HowItWorks class="mb-6 md:mb-0 md:mt-20 xl:mt-40" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/lufthansa/sale/how-it-works.vue'
import VoucherAmountSelector from '~brand-components/lufthansa/sale/voucher-amount-selector.vue'
import StepNavigation from '~brand-components/lufthansa/navigation/step-navigation.vue'

export default Vue.extend({
  components: {
    HowItWorks,
    VoucherAmountSelector,
    StepNavigation,
  },
})
</script>
